export const Localizations = {
  // Login Page
  username: {
    en: "Username",
    fr: "Nom d’utilisateur",
  },
  password: {
    en: "Password",
    fr: "Mot de passe",
  },
  login: {
    en: "Login",
    fr: "Connexion",
  },
  forgotPasswordBtn: {
    en: "Forgot password",
    fr: "Mot de passe oublié",
  },
  createAccBtn: {
    en: "Create Account",
    fr: "Créer un Compte",
  },
  stayLoggedInForHours: {
    en: "Stay logged in for {hours} hours",
    fr: "Stay logged in for {hours} hours",
  },
  help: {
    en: "Help",
    fr: "Aidez-moi",
  },
  newPassword: {
    en: "New Password",
    fr: "Nouveau mot de passe",
  },
  confirmPassword: {
    en: "Confirm Password",
    fr: "Confirmez le mot de passe",
  },
  validationMainText: {
    en: "Your password must contain:",
    fr: "Votre mot de passe doit contenir",
  },
  validationLength: {
    en: "8 - 16 characters",
    fr: "8 - 16 caractères",
  },
  validationUpperAndLowerCase: {
    en: "At least 1 uppercase letter & 1 lowercase letter",
    fr: "Au moins une lettre majuscule et une lettre minuscule",
  },
  validationNumberAndSymbol: {
    en: "At least 1 number and 1 symbol",
    fr: "Au moins 1 chiffre et 1 symbole",
  },
  passAndConfirmPassDontMatch: {
    en: "Password and confirmed password don't match.",
    fr: "Le mot de passe et le mot de passe confirmé ne correspondent pas.",
  },

  // Forgot Password Page
  successResetEmailSecond: {
    en: "Email address",
    fr: "A été envoyé à votre adresse e-mail",
  },

  // ResetPassword
  resetPasswordTitle: {
    en: "Reset Password",
    fr: "Réinitialiser le mot de passe",
  },
  resetPasswordSubmitBtn: {
    en: "Submit",
    fr: "Soumettre",
  },
  setPasswordTitle: {
    en: "Set Password",
    fr: "Définir le mot de passe",
  },

  // SideMenu
  sideMenuLogoutTitle: {
    en: "Logout",
    fr: "Déconnexion",
  },

  sessionHeading: {
    en: "Sessions",
    fr: "Séances",
  },
  sessionTitle: {
    en: "Session",
    fr: "Session",
  },
  materialsTitle: {
    en: "Materials",
    fr: "Matériel",
  },
  assessmentNotificationTitle: {
    en: "COMPLETE YOUR ASSESSMENTS",
    fr: "COMPLÉTEZ VOS ÉVALUATIONS",
  },

  programsTitle: {
    en: "Group Selection",
    fr: "Choisir le Groupe",
  },
  programsTitleSwitch: {
    en: "Group Change",
    fr: "Changement de groupe",
  },
  required: {
    en: "Required",
    fr: "Obligatoire",
  },
  rightsReserved: {
    en: "All rights reserved",
    fr: "Tous les droits sont réservés",
  },
  usedLink: {
    en: "This link for reset password is already used.",
    fr: "Ce lien pour réinitialiser le mot de passe est déjà utilisé.",
  },
  passwordSuccesfullyChanged: {
    en: "Password successfully changed",
    fr: "Mot de passe changé avec succès",
  },
  counsellor: {
    en: "Counsellor/Therapist",
    fr: "Conseiller",
  },
  counsellorMobileView: {
    en: "Counsellor/",
    fr: "Conseiller",
  },
  therapistMobileView: {
    en: "Therapist",
    fr: "",
  },
  date: {
    en: "Date",
    fr: "Date",
  },
  time: {
    en: "Time",
    fr: "Temps",
  },
  duration: {
    en: "Duration",
    fr: "Durée",
  },
  joinSession: {
    en: "Join Session",
    fr: "Rejoindre la session",
  },
  setTimeZone: {
    en: "Set time zone",
    fr: "Définir le fuseau horaire",
  },
  download: {
    en: "Download",
    fr: "Télécharger",
  },
  portalLoginSuccess: {
    en: "Successfully logged into portal",
    fr: "Connexion réussie au portail",
  },
  invalidPassCombination: {
    en: "Invalid Username and Password Combination!",
    fr: "Combinaison de nom d'utilisateur et de mot de passe invalide!",
  },
  emailSentSuccess: {
    en: "Email successfully sent",
    fr: "Email envoyé avec succès",
  },
  invalidEmail: {
    en: "Invalid email",
    fr: "Email invalide",
  },
  sendResetPasswordLink: {
    en: "Send reset link",
    fr: "Envoyer un lien",
  },
  sendEmailBtn: {
    en: "Send email",
    fr: "Envoyer un email",
  },
  timezoneUpdatedSuccess: {
    en: "Time zone updated successfully",
    fr: "FR:Time zone updated successfully",
  },
  noOnlineSession: {
    en: "You are not currently registered for an EHN Online session. If you would like to register for any of our online treatment or counselling programs, please call us at 866-348-1529.",
    fr: "Vous n'êtes pas actuellement inscrit à une session EHN Online. Si vous souhaitez vous inscrire à l'un de nos programmes de traitement ou de conseil en ligne, veuillez nous appeler au 866-348-1529.",
  },
  noClientRequest: {
    en: "You currently don't have any Treatment request.",
    fr: "Vous n'avez actuellement aucune demande de traitement.",
  },
  currentTimeZone: {
    en: "Current time zone",
    fr: "Fuseau horaire actuel",
  },
  timeZoneNotSet: {
    en: "Your current time zone is not set. Please choose your time zone in order to see your sessions and group selection.",
    fr: "Votre fuseau horaire actuel n'est pas défini. Veuillez choisir votre fuseau horaire afin de voir vos sessions et votre sélection de groupe.",
  },
  timeZoneNotSetModal1: {
    en: "Your current time zone is not set.",
    fr: "Votre fuseau horaire actuel n'est pas défini.",
  },
  timeZoneNotSetModal2: {
    en: "Please choose your time zone in order to see your sessions and group selection.",
    fr: "Veuillez choisir votre fuseau horaire afin de voir vos sessions et votre sélection de groupe.",
  },
  selectTimeZone: {
    en: "Select time zone",
    fr: "Sélectionner",
  },
  selectTimeZoneMessage: {
    en: "Please select your time zone to view your online sessions.",
    fr: "Veuillez sélectionner votre fuseau horaire pour visualiser vos sessions en ligne.",
  },
  timeZoneValidationMsg: {
    en: "Please select your time zone.",
    fr: "Veuillez sélectionner votre fuseau horaire.",
  },
  updateTimeZone: {
    en: "Update",
    fr: "Réactualiser",
  },
  backBtn: {
    en: "Back",
    fr: "Retour",
  },
  sessionCancelled: {
    en: "The session has been cancelled. There is no programming scheduled during this time.",
    fr: "La session a été annulée. Il n’y a pas de programmation prévue pendant cette période.",
  },
  programIntroTitle: {
    en: "Group Selection",
    fr: "Choisir le Groupe",
  },
  assessmentNotification: {
    en: "You have pending assessments that need to be completed. Please complete them as soon as possible.",
    fr: "Vous avez des évaluations en attente. Veuillez les compléter dès que possible.",
  },
  programIntroText1: {
    en: "It's time to choose your group(s) for the next phase of your programming! Spaces are limited! Please take a few minutes to choose your group time(s).",
    fr: "C'est le moment de choisir votre/vos groupe(s) pour la prochaine phase de votre programme! Les places sont limitées! Veuillez prendre quelques minutes pour choisir l'horaire de votre/vos groupe(s).",
  },
  programIntroText3: {
    en: "Would you like to continue?",
    fr: "Voulez-vous continuer?",
  },
  selectGroupTitle: {
    en: "SELECT ADDITIONAL GROUP",
    fr: "SÉLECTIONNER UN GROUPE SUPPLÉMENTAIRE",
  },
  noGroupsAvailable: {
    en: "SCHEDULING ERROR",
    fr: "ERREUR DE PLANIFICATION",
  },
  programSelectionWarning: {
    en: "PROGRAMS",
    fr: "PROGRAMMES",
  },
  programWarningMessage1: {
    en: "This group has 2 or fewer spaces remaining, which may be filled before we receive your request. Please select an additional group time as a second choice in case there is no longer capacity in your preferred group.",
    fr: "Ce groupe a moins de deux places de disponibles, qui peuvent être prises avant que nous recevions votre demande. Veuillez sélectionner une autre heure de groupe comme deuxième choix au cas où votre premier choix de groupe n'est plus disponible.",
  },
  programWarningMessage3: {
    en: "This group has 2 or fewer spaces remaining, which may be filled before we receive your request. Should this occur, we will contact you to discuss other options.",
    fr: "Ce groupe a moins de deux places de disponibles, qui peuvent être prises avant que nous recevions votre demande. Si cela arrive, nous vous contacterons pour discuter des options possibles.",
  },
  programWarningMessage4: {
    en: "There has been a scheduling error, please contact your Client Care Coordinator for assistance with registration.",
    fr: "Erreur de planification. Veuillez contacter votre coordonateur/coordonatrice pour obtenir de l'aide concernant l'inscription.",
  },
  programSelectionSuccess: {
    en: "Your Selection has successfully been submitted for review.",
    fr: "Votre choix a été soumis pour révision.",
  },
  programSelectionError: {
    en: "There has been an error with submitting your request.  Please try again later.",
    fr: "Une erreur est survenue en soumettant votre choix. Veuillez réessayer plus tard.",
  },
  chooseAssessmentOption: {
    en: "Complete Now",
    fr: "COMPLÉTER MAINTENANT",
  },
  laterAssessmentOption: {
    en: "Later",
    fr: "PLUS TARD",
  },
  chooseOption: {
    en: "Choose Now",
    fr: "Choisir Maintenant",
  },
  laterOption: {
    en: "Later",
    fr: "Choisir plus tard",
  },
  confirm: {
    en: "Confirm",
    fr: "Confirmez",
  },
  close: {
    en: "Close",
    fr: "Fermer",
  },
  /*Start: Assessments*/
  noAssessments: {
    en: "You currently do not have outstanding assessments requiring completion.",
    fr: "Vous n’avez actuellement aucune évaluation en attente nécessitant d’être complétée.",
  },
  currentAssessmentsTitle: {
    en: "Current Assessments",
    fr: "Évaluations actuelles",
  },
  dueDate: {
    en: "Due date",
    fr: "Date d'échéance",
  },
  completeAssessmentsMsg: {
    en: "Please complete the following set of assessments. Assessments are an important part of your care at EHN. They measure your symptoms and allow you and your clinical team to ensure treatment is meeting your needs.",
    fr: "Veuillez compléter les évaluations suivantes. Ces évaluations constituent un élément important de votre prise en charge au sein de l'EHN. Elles permettent d'évaluer vos symptômes et de vous assurer, ainsi qu'à votre équipe soignante, que le traitement répond à vos besoins.",
  },
  completeAssessmentsBtn: {
    en: "Complete Assessments",
    fr: "Évaluations complètes",
  },
  /*End: Assessments*/

  /* Start: ModalDeselectGroupInfo */
  modalDeselectGroupTitle: {
    en: "Deselect Group",
    fr: "Désélectionner Groupe",
  },

  modalDeselectGroupMessagePart1: {
    en: "You have already selected",
    fr: "You have already selected",
  },
  modalDeselectGroupMessagePart2: {
    en: "group on ",
    fr: "group on ",
  },
  modalDeselectGroupMessagePart4: {
    en: " starting from the week of ",
    fr: " starting from the week of ",
  },
  modalDeselectGroupMessagePart3: {
    en: "Please deselect that group before selecting another one.",
    fr: "Please deselect that group before selecting another one.",
  },
  /* End: ModalDeselectGroupInfo */

  introParagraphPart1: {
    en: "Your program finishes ",
    fr: "Votre programme se termine le ",
  },
  introParagraphPart2: {
    en: "Please choose a weekly group time for the next portion of your program, which will begin the week of",
    fr: "Veuillez choisir un horaire pour votre suivi hebdomadaire pour la prochaine portion de votre programme, qui débutera la semaine du",
  },
  introParagraphPart3: {
    en: "Space is limited so make your selection as soon as possible.",
    fr: "Les places sont limitées alors veuillez faire votre choix le plus rapidement possible.",
  },
  introParagraphPart4: {
    en: "Please keep in mind that you cannot select 2 groups on the same day.",
    fr: "Veuillez garder en tête que vous ne pouvez pas choisir 2 groupes dans la même journée.",
  },
  introParagraphPart5: {
    en: "Please review your group selection before submitting your request.",
    fr: "Veuillez réviser votre choix d'horaire de groupe avant de soumettre votre demande.",
  },
  introParagraphPart6: {
    en: "Your client care coordinator will review your selection to ensure space is still available and then send you an email confirmation.",
    fr: "Votre coordonateur/coordonatrice de service aux clients va réviser votre choix afin de s'assurer que le groupe est encore disponible et vous enverra un courriel de confirmation.",
  },
  introParagraphPart7: {
    en: "Please select a group time for the next group in your program.",
    fr: "Veuillez choisir un horaire pour le prochain groupe dans votre programme.",
  },
  switchParagraphPart1: {
    en: "You have requested to change the session time of ",
    fr: "Veuillez choisir un horaire pour le prochain groupe dans votre programme ",
  },
  reviewAndSubmit: {
    en: "Review and Submit",
    fr: "Réviser et Soumettre",
  },
  deselect: {
    en: "Deselect",
    fr: "Désélectionner",
  },
  select: {
    en: "Select",
    fr: "Sélectionner",
  },
  previous: {
    en: "Previous",
    fr: "Précédent",
  },
  next: {
    en: "Next",
    fr: "Suivant",
  },
  submit: {
    en: "Submit",
    fr: "Soumettre",
  },
  spaces: {
    en: "Spaces",
    fr: "Disponibilités",
  },
  groupName: {
    en: "Group Name",
    fr: "Nom du groupe",
  },

  startDateTime: {
    en: "Start Date/Time",
    fr: "Date de commencement/Heure",
  },
  startDateTimeMobFirtsPart: {
    en: "Start Date/Time",
    fr: "Date de commencement/",
  },
  startDateTimeMobSecondPart: {
    en: "",
    fr: "Heure",
  },
  switchStartDateTime: {
    en: "Change Date/Time",
    fr: "Date de commencement/Heure",
  },
  switchStartDateTimeMobFirstPart: {
    en: "Change Date/Time",
    fr: "Date de commencement/",
  },
  switchStartDateTimeMobSecondPart: {
    en: "",
    fr: "Heure",
  },
  endDateTime: {
    en: "End Date/Time",
    fr: "Date de fin/Heure",
  },
  rejected: {
    en: "Rejected",
    fr: "Rejeté",
  },
  approved: {
    en: "Approved",
    fr: "Approuvé",
  },
  pending: {
    en: "Pending",
    fr: "En Attente",
  },
  group: {
    en: "Group",
    fr: "Groupe",
  },
  submittedRequest: {
    en: "Submitted Request",
    fr: "Soumettre la demande",
  },
  treatmentsTitle: {
    en: "Treatment Programs",
    fr: "Traitements",
  },
  action: {
    en: "Action",
    fr: "Action",
  },
  status: {
    en: "Status",
    fr: "État",
  },
  selectGroup: {
    en: "Select Group",
    fr: "Sélectionnez Groupe",
  },
  noGroupsOnDate: {
    en: "There are currently no groups with spaces available during this time period.",
    fr: "Il n'y a pas de groupe ou de disponibilité durant la période choisit.",
  },
  selectADay: {
    en: "Select a day:",
    fr: "Veuillez choisir une journée:",
  },
  selectFirstAvailableWeek: {
    en: "Select week to start",
    fr: "Sélectionner la semaine où vous allez débuter",
  },
  // assessments

  assessmentsTitle: {
    en: "Assessments",
    fr: "Évaluations",
  },
  cancel: {
    en: "Cancel",
    fr: "Annuler",
  },

  // Text Message Reminders modal
  textMessageReminderTitle: {
    en: "Text Message Reminders",
    fr: "Rappels par message texte",
  },
  textMessageReminderPartOne: {
    en: "Would you like to receive text message reminders about your upcoming sessions, program assessments, and other important program information?",
    fr: "Souhaitez-vous recevoir des rappels par texto concernant vos prochaines séances, vos évaluations du programme et d’autres informations importantes ?",
  },
  textMessageReminderPartTwo: {
    en: "This is a convenient and timely way to stay up to date with your program!",
    fr: "C’est un moyen pratique et rapide de rester à jour avec votre programme!",
  },
  yes: {
    en: "Yes",
    fr: "Oui",
  },
  later: {
    en: "Later",
    fr: "Plus tard",
  },
  noThanks: {
    en: "No Thanks",
    fr: "Non merci",
  },

  // Text messages
  textMessages: {
    en: "Text Messages",
    fr: "Messages texte",
  },
  consentTitle: {
    en: "Consent to text messaging from EHN outpatient services",
    fr: "CONSENTEMENT AUX MESSAGES TEXTES DE LA PART DES SERVICES EXTERNES EHN",
  },
  consentText: {
    en: `
          <p class="consent-paragraph">With my consent, EHN Outpatient Services will send me text message reminders about my upcoming sessions, program assessments, and other important program information.</p>
          <p class="consent-paragraph">I understand that EHN Outpatient Services will only send me text messages with my permission. I acknowledge that these text messages are an additional service, and that I remain responsible for attending my sessions and completing my assessments on time. I may opt out at any time by replying <span class="consent-stop-word">ehnstop</span> to any message. For assistance, I can contact <a href="mailto:wagonsupport@ehncanada.com" class="support-email">wagonsupport@ehncanada.com</a>. By consenting to receiving text messages, I also agree to the <a href="/terms" class="terms-of-use-link">Terms of Use</a> and <a href="https://www.edgewoodhealthnetwork.com/privacy-wagon/" target="_blank" class="privacy-policy-link">Privacy Policy</a>.</p>
          <p class="consent-paragraph">This service is <span class="consent-optional-word">optional</span>. I understand I will continue to receive email reminders whether or not I choose to receive text messages.</p>
          <h3 class="mb-1">Important Privacy Information</h3>
          <p class="consent-paragraph">Text messages are <span class="consent-not-confidential">not confidential</span>. Anyone with access to my mobile phone may be able to view them. My mobile phone provider and EHN Outpatient Services may also have access to these messages. Message and data rates may apply, depending on my provider and data plan.</p>
          <h3 class="mb-1">Consent Confirmation</h3>
          <p class="consent-paragraph">By selecting “Yes” and providing my mobile phone number below, I agree to receive text messages from EHN Outpatient Services. I understand this service is optional and that I can opt out at any time.</p>
        `,
    fr: `
          <p class="consent-paragraph">Avec mon consentement, les Services Externes EHN m’enverront des messages textes pour me rappeler mes prochaines séances, les évaluations du programme ainsi que d’autres informations importantes liées au programme.</p>
          <p class="consent-paragraph">Je comprends que les Services Externe EHN ne m’enverront des messages textes qu’avec mon consentement. Je reconnais que ces messages textes constituent un service supplémentaire et que je reste responsable de ma présence aux séances et de compléter mes évaluations à temps. Je peux me désinscrire à tout moment en répondant <span class="consent-stop-word">ehnstop</span> à n’importe quel message. Pour toute assistance, je peux contacter <a href="mailto:wagonsupport@ehncanada.com" class="support-email">wagonsupport@ehncanada.com</a>. En consentant à recevoir des messages textes, j’accepte également <a href="/terms" class="terms-of-use-link">les Conditions d’utilisation</a> et <a href="https://www.edgewoodhealthnetwork.com/privacy-wagon/" target="_blank" class="privacy-policy-link">la Politique de Confidentialité</a>.</p>
          <p class="consent-paragraph">Ce service est <span class="consent-optional-word">optionnel</span>. Je comprends que je continuerai à recevoir des rappels par courriel que je choisisse ou non de recevoir des messages textes.</p>
          <h3 class="mb-1">Informations Importantes sur la Confidentialité</h3>
          <p class="consent-paragraph">Les messages textes ne sont <span class="consent-not-confidential">pas confidentiels</span>. Toute personne ayant accès à mon cellulaire pourrait les consulter. Mon opérateur mobile ainsi que les Services Externes EHN peuvent également avoir accès à ces messages. Des frais de messagerie et de données peuvent s’appliquer selon votre fournisseur et votre forfait.</p>
          <h3 class="mb-1">Confirmation du Consentement</h3>
          <p class="consent-paragraph">En sélectionnant “Oui” et en fournissant mon numéro de téléphone portable ci-dessous, j’accepte de recevoir des messages textes de la part des Services Externes EHN. Je comprends que ce service est facultatif et que je peux me désinscrire à tout moment.</p>
        `,
  },
  acceptConsentErrorMessage: {
    en: "Please accept the consent to continue.",
    fr: "Veuillez accepter le consentement pour continuer.",
  },
  phoneErrorMessage: {
    en: "Please use the following phone number pattern, e.g.: (416) 123-4567",
    fr: "Veuillez utiliser le format de numéro de téléphone suivant, par exemple: (416) 123-4567",
  },

  // Opted in view
  optedInTitle: {
    en: "Text Messages",
    fr: "MESSAGES TEXTES",
  },
  optedInTextPartOne: {
    en: "You are subscribed to text messages from EHN Outpatient Services.",
    fr: "Vous êtes abonné(e) aux messages texte des Services Externes EHN.",
  },
  optedInTextPartTwo: {
    en: "You can change your mobile phone number or unsubscribe by changing the settings below.",
    fr: "Vous pouvez changer votre numéro de téléphone ou vous désabonner en modifiant les paramètres ci-dessous.",
  },
  termsOfUse: {
    en: "Terms of Use",
    fr: "Les Conditions d’utilisation",
  },
  optedInConfirmBtn: {
    en: "Confirm",
    fr: "Confirmer",
  },

  // Not to subscribe to text messages modal
  notToSubscribe: {
    en: "You have chosen not to subscribe to text messages from EHN Outpatient Services. If you change your mind, you can opt in at any time by going to the ",
    fr: "Vous avez choisi de ne pas recevoir de messages texte de la part des Services Externes EHN. Si vous changez d’avis, vous pouvez modifier votre choix à tout moment en vous rendant dans l’onglet ",
  },
  tab: {
    en: " tab.",
    fr: " pour vous inscrire.",
  },

  // Start: Verification Code modal
  verificationCodeModalTitle: {
    en: "Verification Code",
    fr: "Code de vérification",
  },
  verificationCodeModalPartOne: {
    en: "Please enter the verification code sent to your mobile phone.",
    fr: "Veuillez saisir le code de vérification envoyé sur votre cellulaire.",
  },
  didntReceiveCode: {
    en: "Didn't receive the code?",
    fr: "Vous n’avez pas reçu le code ?",
  },
  verificationCodeExpiredMsg: {
    en: "Your verification code has expired. Please request a new code.",
    fr: "Votre code de vérification a expiré. Veuillez demander un nouveau code.",
  },
  verificationCodeDoesNotMatchErrorP1: {
    en: "Verification code does not match.",
    fr: "Le code de vérification ne correspond pas.",
  },
  verificationCodeDoesNotMatchErrorP2: {
    en: "Please try again, or request a new code.",
    fr: "Veuillez réessayer ou demander un nouveau code.",
  },
  checkYourPhoneMsg: {
    en: "Check your phone number or",
    fr: "Vérifiez votre numéro de téléphone ou",
  },
  requestNewCode: {
    en: "request a new code",
    fr: "demander un nouveau code",
  },
  verificationCodeExpiredTitle: {
    en: "Verification Code Expired",
    fr: "Le code de vérification a expiré",
  },
  maxAttempsExceededErrorMsg: {
    en: "You have reached the maximum number of attempts.",
    fr: "Vous avez atteint le nombre maximum de tentatives.",
  },
  maxCodeRequestAttemptsExceededErrorMsg: {
    en: "You have reached the maximum number of code request attempts.",
    fr: "Vous avez atteint le nombre maximum de tentatives de demande de code.",
  },
  tryIn30Minutes: {
    en: "Please try again in",
    fr: "Veuillez réessayer dans",
  },
  getNewVerificationCode: {
    en: "Request New Code",
    fr: "Demander un nouveau code",
  },
  // End: Verification Code modal

  ok: {
    en: "OK",
    fr: "OK",
  },
  cuccessfullyChangedPhoneNumber: {
    en: "Your phone number has been successfully changed.",
    fr: "Le numéro de téléphone a été modifié avec succès.",
  },
  smsError: {
    en: "An error occurred. Please contact",
    fr: "Une erreur s’est produite. Veuillez contacter",
  },

  // Unsubscribe modal
  unsubscribeToSMSModalTitle: {
    en: "Unsubscribe to Text Messaging",
    fr: "Désabonnement aux messages textes",
  },
  unsubscribePartOne: {
    en: "You have chosen to opt out of receiving further text messages from EHN Outpatient Services.",
    fr: "Vous avez choisi de ne plus recevoir de messages textes de la part des Services Externes EHN.",
  },
  unsubscribePartTwo: {
    en: "You can opt in again anytime by changing these settings.",
    fr: "Vous pouvez vous réabonner à tout moment en modifiant ces paramètres.",
  },
  unsubscribeContinue: {
    en: "Are you sure you want to continue?",
    fr: "Êtes-vous sûr de vouloir continuer ?",
  },
  no: {
    en: "No",
    fr: "Non",
  },

  // Unsubscribe Confirmation modal
  unsubscribeConfirmationModalTitle: {
    en: "Unsubscribe Confirmation",
    fr: "Confirmation de désabonnement ",
  },
  unsubscribeConfirmationModalText: {
    en: "You will no longer receive text messages from EHN Outpatient Services. You can opt-in again anytime.",
    fr: "Vous ne recevrez plus de messages textes de la part des Services Externes EHN. Vous pouvez vous réabonner à tout moment.",
  },

  // Terms of use
  termsOfUseTitle: {
    en: "EHN Outpatient Services – Text Messaging Terms",
    fr: "SERVICES EXTERNES EHN – CONDITIONS D’UTILISATION DES MESSAGES TEXTES",
  },
  termsOfUseText: {
    en: `
          <p class="terms-of-use-paragraph">When you choose to receive text messages from EHN Outpatient Services Inc., you agree to the following:</p>
          <h3 class="mb-1">Purpose of Messages</h3>
          <p class="terms-of-use-paragraph">We will use text messages to remind you about upcoming sessions, program assessments, or other important service-related information. We will not use text messages for marketing or promotional purposes.</p>
          <h3 class="mb-1">Consent</h3>
          <p class="terms-of-use-paragraph">By opting in, you agree to receive these service-related messages at the mobile number you provide.</p>
          <h3 class="mb-1">Costs</h3>
          <p class="terms-of-use-paragraph">We do not charge for this service, but your mobile carrier’s standard message or data rates may apply.</p>
          <h3 class="mb-1">Frequency</h3>
          <p class="terms-of-use-paragraph">The number of text messages you receive will depend on your treatment program and scheduled sessions.</p>
          <h3 class="mb-1">Opt-Out</h3>
          <p class="terms-of-use-paragraph">You can stop receiving text messages at any time by replying EHNSTOP to any message or by changing settings on the Text Messages page inside EHN Online Portal. You will receive a confirmation text message, and no further messages will be sent.</p>
          <p class="terms-of-use-paragraph">Your information will only be used to deliver these text messages. It may be shared with our text messaging service providers and your mobile carrier as needed to deliver the service, but will not be sold or shared for marketing purposes. For more details, please see our <a href="https://www.edgewoodhealthnetwork.com/privacy-wagon/" target="_blank" class="privacy-policy-link">Privacy Policy</a>.</p>
          <h3 class="mb-1">Contact</h3>
          <p class="terms-of-use-paragraph">If you have questions or need support, please email <a href="mailto:wagonsupport@ehncanada.com" class="support-email">wagonsupport@ehncanada.com</a>.</p>
        `,
    fr: `
          <p class="terms-of-use-paragraph">Lorsque vous choisissez de recevoir des messages textes de la part de Services Externes EHN Inc., vous acceptez ce qui suit :</p>
          <h3 class="mb-1">Objectif des messages</h3>
          <p class="terms-of-use-paragraph">Nous utiliserons les messages textes pour vous rappeler vos prochaines séances, vos évaluations de programme ou d’autres informations importantes liées aux services. Les messages textes ne seront pas utilisés à des fins de marketing ou promotionnelles.</p>
          <h3 class="mb-1">Consentement</h3>
          <p class="terms-of-use-paragraph">En choisissant de recevoir ces messages, vous acceptez que des messages liés aux services soient envoyés au numéro de téléphone portable que vous fournissez.</p>
          <h3 class="mb-1">Coûts</h3>
          <p class="terms-of-use-paragraph">Nous ne facturons pas ce service, mais les frais standard de messagerie ou de données de votre opérateur mobile peuvent s’appliquer.</p>
          <h3 class="mb-1">Fréquence</h3>
          <p class="terms-of-use-paragraph">Le nombre de messages texte que vous recevrez dépendra de votre programme de traitement et des séances prévues.</p>
          <h3 class="mb-1">Désinscription</h3>
          <p class="terms-of-use-paragraph">Vous pouvez arrêter de recevoir des messages textes à tout moment en répondant EHNSTOP à un message ou en modifiant les paramètres sur la page de notifications SMS dans le portail en ligne d’EHN. Vous recevrez un message de confirmation et aucun autre message ne vous sera envoyé.</p>
          <h3 class="mb-1">Confidentialité</h3>
          <p class="terms-of-use-paragraph">Vos informations ne seront utilisées que pour l’envoi de ces messages textes. Elles peuvent être partagées avec nos prestataires de services de messagerie texte et votre opérateur mobile si nécessaire pour fournir le service, mais ne seront ni vendues ni partagées à des fins de marketing. Pour plus de détails, veuillez consulter notre <a href="https://www.edgewoodhealthnetwork.com/privacy-wagon/" target="_blank" class="privacy-policy-link">Politique de Confidentialité</a>.</p>
          <h3 class="mb-1">Contact</h3>
          <p class="terms-of-use-paragraph">Si vous avez des questions ou besoin d’assistance, SVP envoyer un courriel à <a href="mailto:wagonsupport@ehncanada.com" class="support-email">wagonsupport@ehncanada.com</a>.</p>
        `,
  },
  backToConsentBtn: {
    en: "Back to consent",
    fr: "Retour au formulaire de consentement",
  },
  verificationModalTitle: {
    en: "Identity Verification Required",
    fr: "Vérification d'identité requise",
  },
  verificationModalBody: {
    en: "Please verify your identity to continue using the portal. This is a one-time process that helps ensure your account security.",
    fr: "Veuillez vérifier votre identité pour continuer à utiliser le portail. Il s'agit d'un processus unique qui contribue à la sécurité de votre compte.",
  },
  verifyNow: {
    en: "Verify Now",
    fr: "Vérifier maintenant",
  },

  // Identity Verification Modal
  identityVerificationModalTitle: {
    en: "IMPORTANT UPDATE: Identity Verification for Your Sessions",
    fr: "MISE À JOUR IMPORTANTE : Vérification d’identité pour vos séances",
  },
  identityVerificationModalStartingWord: {
    en: "Starting ",
    fr: "À compter du ",
  },
  identityVerificationModalStartDate: {
    en: "Monday April 27",
    fr: "lundi 27 avril",
  },
  identityVerificationModalToSupport: {
    en: ", to support the safety and confidentiality of your sessions, we are introducing a brief identity verification step before joining your sessions.",
    fr: ", afin de soutenir la sécurité et la confidentialité de vos séances, nous mettons en place une brève étape de vérification d’identité avant que vous ne puissiez vous joindre à vos séances.",
  },
  identityVerificationModalYouWillBePrompted: {
    en: "You will be prompted for your ",
    fr: "Il vous sera demandé de fournir ",
  },
  identityVerificationModalFirstName: {
    en: "First Name, ",
    fr: "votre prénom, ",
  },
  identityVerificationModalLastName: {
    en: "Last Name, ",
    fr: "nom de famille ",
  },
  identityVerificationModalAnd: {
    en: "and ",
    fr: "et ",
  },
  identityVerificationModalDateOfBirth: {
    en: "Date of Birth. ",
    fr: "date de naissance. ",
  },
  identityVerificationModalPartThree: {
    en: "This information will be securely verified against your clinical record before you are admitted into your session.",
    fr: "Ces renseignements seront vérifiés de façon sécurisée avec votre dossier clinique avant que vous soyez admis à votre séance.",
  },
  identityVerificationModalContinue: {
    en: "Continue",
    fr: "Continuer",
  },
};
